module.exports = __webpack_public_path__ + "img/525050_D4D3D3_959393_ACACAC-256px.5877e3be.png";